import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { GridComponent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { PtLuxonDate } from '../../../../../models/projects/date.models';
import { standaloneReadingColumns } from './weather-log-standalone-reading.config';
import { WeatherLogStandaloneEditor } from '../../../../../models/weather-readings/weather-readings.models';
import {
  WeatherLogAdditionalReadingService
} from '../../../../../services/weather-readings/weather-log-additional-reading.service';

@Component({
  selector: 'weather-log-standalone-reading-grid',
  templateUrl: 'weather-log-standalone-reading-grid.html'
})
export class WeatherLogStandaloneReadingGridComponent {
  @Input() dailyLogDate: PtLuxonDate;
  @Input() projectId: number;
  @Output() public addStandaloneReadingClicked: EventEmitter<void> = new EventEmitter();
  @Output() public deleteStandaloneReadingClicked: EventEmitter<WeatherLogStandaloneEditor> = new EventEmitter();
  @ViewChild('additionalReadingsGrid') additionalReadingsGrid?: GridComponent;

  gridData: GridDataResult;
  columns = standaloneReadingColumns;
  standaloneReadings: WeatherLogStandaloneEditor[];
  gridLoading: boolean;

  state: State = {
    take: 5,
    skip: 0,
    filter: {
      logic: 'and',
      filters: []
    },
    sort: [
      {
        field: 'effectiveFromDate',
        dir: 'asc'
      },
    ],
  };

  constructor(private weatherLogAdditionalReadingService: WeatherLogAdditionalReadingService)
  {

  }

  ngOnInit() {
    this.gridLoading = true;
    this.loadGrid(this.projectId);
  }

  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
    this.loadItems();
  }

  emitDeleteStandaloneReading(row: WeatherLogStandaloneEditor) {
    this.deleteStandaloneReadingClicked.emit(row);
  }

  emitAddStandaloneReading() {
    this.addStandaloneReadingClicked.emit();
  }

  async loadGrid(projectId: number) {
    this.weatherLogAdditionalReadingService.getGridData(this.dailyLogDate.dateTime, projectId).then(data => {
      this.standaloneReadings = data;
      this.loadItems();
      this.gridLoading = false;
    });
  }

  private loadItems(): void {
    this.gridData = process(this.standaloneReadings, this.state);
  }
}



// WEBPACK FOOTER //
// ./src/pages/weather-readings/weather-log-manage-readings/components/weather-log-standalone-reading-grid/weather-log-standalone-reading-grid.ts